import { render, staticRenderFns } from "./SortsDialog.vue?vue&type=template&id=d3ff7de6"
import script from "./SortsDialog.vue?vue&type=script&lang=js"
export * from "./SortsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports